var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAddPosition = function SvgAddPosition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.442a.723.723 0 0 1-.716.716l-3.09.034-.034 3.092a.724.724 0 0 1-.716.716.702.702 0 0 1-.708-.708l.035-3.18-3.18.034a.702.702 0 0 1-.708-.708.723.723 0 0 1 .716-.716l3.09-.034.034-3.092a.724.724 0 0 1 .717-.716.702.702 0 0 1 .707.707l-.034 3.182 3.18-.035a.702.702 0 0 1 .707.708zM13.726 0a2.574 2.574 0 0 1 2.573 2.575v.858h-1.286v-.858c0-.711-.576-1.288-1.287-1.288H4.717v7.724h4.72v1.287H2.574A2.574 2.574 0 0 1 0 7.724v-5.15A2.574 2.574 0 0 1 2.574 0h11.152zM3.43 1.287h-.857c-.711 0-1.287.577-1.287 1.288v5.149c0 .71.576 1.287 1.287 1.287h.857V1.287z",
    fill: "#FFF"
  })));
};

export default SvgAddPosition;